import {
  OPEN_MATERIALS_EDIT_MODAL,
  CLOSE_MATERIALS_EDIT_MODAL,
  UPDATE_SALE_MATERIALS_REQUEST,
  UPDATE_SALE_MATERIALS_SUCCESS,
  UPDATE_SALE_MATERIALS_FAILURE
} from 'actions/materials-actions';

import {
  ADD_MATERIAL,
  REMOVE_MATERIAL,
  CHANGE_MATERIAL_BRAND
} from 'actions/brand-series-actions';

const INITIAL_STATE = {
  data: { materials: [{}] },
  materialsBrandSeries: [[]],
  showModal: false,
  loading: false,
  error: null
};

const MaterialsReducer = (state = INITIAL_STATE, action) => {
  let error;
  switch (action.type) {
    case ADD_MATERIAL:
      return {
        ...state,
        materialsBrandSeries: [...state.materialsBrandSeries, []]
      };

    case REMOVE_MATERIAL:
      const materialsBrandSeries = [...state.materialsBrandSeries];
      materialsBrandSeries.splice(action.payload, 1);
      return {
        ...state,
        materialsBrandSeries
      };

    case CHANGE_MATERIAL_BRAND:
      return {
        ...state,
        materialsBrandSeries: action.payload
      };

    case OPEN_MATERIALS_EDIT_MODAL:
      const soldDetails = action.payload;
      // Ensure we have at least one material even if the sale has none
      let materials = soldDetails.materials && soldDetails.materials.length > 0 
        ? soldDetails.materials 
        : [{}];
          
      // Transform materials to have the correct field names for the form
      materials = materials.map(material => ({
        id: material.id,
        // Map material_brand_id to brand field for the form
        brand: material.material_brand_id,
        // Map brand_item_id to brand_series field for the form
        brand_series: material.brand_item_id,
        color: material.color
      }));
      
      // Initialize brand series arrays with same length as materials
      const brandSeries = materials.map(() => []);
      
      return {
        ...state,
        data: { materials },
        materialsBrandSeries: brandSeries,
        showModal: true,
        loading: false
      };

    case CLOSE_MATERIALS_EDIT_MODAL:
      return {
        ...state,
        showModal: false,
        loading: false
      };

    case UPDATE_SALE_MATERIALS_REQUEST:
      return {
        ...state,
        loading: true
      };

    case UPDATE_SALE_MATERIALS_SUCCESS:
      return {
        ...state,
        data: { materials: action.payload.materials },
        showModal: false,
        loading: false
      };

    case UPDATE_SALE_MATERIALS_FAILURE:
      error = action.payload || { message: action.payload.message };
      return {
        ...state,
        error: error,
        showModal: true,
        loading: false
      };

    default:
      return state;
  }
};

export default MaterialsReducer;
